import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes, FaWhatsapp } from "react-icons/fa";
import logo from "../assets/RRI Logo-03 final .png";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    if (location.pathname !== "/") {
      window.location.href = `/${id}`;
      return;
    }
    const section = document.querySelector(id);
    if (section) section.scrollIntoView({ behavior: "smooth" });
    setOpen(false);
  };

  const openWhatsApp = () => {
    const phone = "+918005885520";
    const msg = encodeURIComponent("Hello! I would like to get a quote.");
    window.open(`https://wa.me/${phone}?text=${msg}`, "_blank");
  };

  return (
    <>
      <header className={`header ${scrolled ? "scrolled" : ""}`}>
        <div className="header-container">
          {/* Logo */}
          <div className="logo-section" onClick={() => scrollToSection("#home")}>
            <img src={logo} alt="Rama Reflection India Pvt Ltd" className="logo-img" />
          </div>

          {/* Desktop Menu */}
          <nav className="desktop-nav">
            <a onClick={() => scrollToSection("#home")}>Home</a>
            <a onClick={() => scrollToSection("#about")}>About</a>
            <a onClick={() => scrollToSection("#services")}>Services</a>
            <a onClick={() => scrollToSection("#projects")}>Projects</a>

            <a onClick={() => scrollToSection("#contact")}>Contact</a>

            <button onClick={openWhatsApp} className="quote-btn">
              <FaWhatsapp /> Get a Quote
            </button>

            {/* Download PDF */}
            {/* <a href="/RRI Profile.pdf" download className="quote-btn">   
              Download 
            </a> */}
          </nav>

          {/* Mobile Toggle */}
          <button className="menu-toggle" onClick={() => setOpen(!open)}>
            {open ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {open && (
          <div className="mobile-menu">
            <a onClick={() => scrollToSection("#home")}>Home</a>
            <a onClick={() => scrollToSection("#about")}>About</a>
            <a onClick={() => scrollToSection("#services")}>Services</a>
            <a onClick={() => scrollToSection("#projects")}>Projects</a>
            <a onClick={() => scrollToSection("#technology")}>Technology</a>

            <a onClick={() => scrollToSection("#contact")}>Contact</a>

            <button onClick={openWhatsApp} className="quote-btn mobile">
              <FaWhatsapp /> Get a Quote
            </button>

            {/* Mobile Download PDF */}
            {/* <a href="/RRI Profile.pdf" download className="quote-btn mobile">
              Download
            </a> */}
          </div>
        )}
      </header>

      {/* ===== FULL RESPONSIVE CSS ===== */}
      <style jsx>{`
        .header {
          position: fixed;
          width: 100%;
          background: #ffffff;
          z-index: 999;
          transition: 0.3s ease;
        }

        .header.scrolled {
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        }

        .header-container {
          width: 100%;
          max-width: 1700px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          padding: 0.5rem 2rem;
          gap: 2rem;
        }

        .logo-section {
          display: flex;
          align-items: center;
          cursor: pointer;
          margin-right: auto;
        }

        .logo-img {
          height: 85px;
          object-fit: contain;
          transition: 0.3s ease;
        }

        .header.scrolled .logo-img {
          height: 75px;
        }

        .desktop-nav {
          display: flex;
          align-items: center;
          gap: 1.7rem;
          margin-left: auto;
        }

        .desktop-nav a {
          font-weight: 500;
          color: #333;
          cursor: pointer;
          text-decoration: none;
          position: relative;
        }

        .desktop-nav a:hover::after {
          width: 100%;
        }

        .desktop-nav a::after {
          content: "";
          width: 0%;
          height: 2px;
          background: #00aeffff;
          position: absolute;
          bottom: -3px;
          left: 0;
          transition: 0.3s ease;
        }

        .quote-btn {
          background: #00aeffff;
          color: white;
          padding: 0.6rem 1.2rem;
          border-radius: 25px;
          border: none;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 0.4rem;
          cursor: pointer;
          transition: 0.3s;
        }

        .quote-btn:hover {
          background: #45d6ff;
        }

        .menu-toggle {
          display: none;
          background: none;
          border: none;
          color: #255972;
          cursor: pointer;
        }

        .mobile-menu {
          width: 100%;
          background: white;
          padding: 1.3rem 1.5rem;
          display: flex;
          flex-direction: column;
          gap: 1rem;
          box-shadow: 0 5px 12px rgba(0, 0, 0, 0.1);
          animation: slideDown 0.3s ease;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .quote-btn.mobile {
          width: 100%;
          justify-content: center;
        }

        @media (max-width: 1200px) {
          .header-container {
            padding: 0.5rem 1.5rem;
          }
        }

        @media (max-width: 992px) {
          .desktop-nav {
            display: none;
          }
          .menu-toggle {
            display: block;
          }
        }

        @media (max-width: 480px) {
          .logo-img {
            height: 60px;
          }
          .header-container {
            padding: 0.5rem 1rem;
          }
        }

        @media (max-width: 360px) {
          .logo-img {
            height: 55px;
          }
        }
      `}</style>
    </>
  );
}


